import {RootState} from '../rootReducer';
import {modelSelector} from '../model';

export const userExpertiseSelector = (state: RootState) => state.userExpertise;
export const modelSelectorBuilder = (uuid: string) => (state: RootState) => modelSelector(state).models[uuid];
